import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import type { PropType } from 'vue';

// Personal
import { NotificationTypeEnum } from '@shared/enum/notification.enum';


export default /*#__PURE__*/_defineComponent({
  __name: 'QNotificationIcon',
  props: {
  notificationType: String as PropType<NotificationTypeEnum>,
},
  setup(__props) {

// Vendor


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (__props.notificationType != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.notificationType == _unref(NotificationTypeEnum).SUCCESS)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: "done",
              role: "presentation",
              "aria-hidden": "true",
              size: "md"
            }))
          : _createCommentVNode("v-if", true),
        (__props.notificationType == _unref(NotificationTypeEnum).ERROR)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 1,
              name: "error",
              role: "presentation",
              "aria-hidden": "true",
              size: "md"
            }))
          : _createCommentVNode("v-if", true),
        (__props.notificationType == _unref(NotificationTypeEnum).WARNING)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 2,
              name: "warning",
              role: "presentation",
              "aria-hidden": "true",
              size: "md"
            }))
          : _createCommentVNode("v-if", true),
        (__props.notificationType == _unref(NotificationTypeEnum).INFO)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 3,
              name: "info",
              role: "presentation",
              "aria-hidden": "true",
              size: "md"
            }))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})